export const relativeEditModel = ({ _id, id, role, pivot, roles }) => {
  const roleLabel = role || pivot?.guardian_role;
  const preparedRole = roles.find((r) => r.label === roleLabel);

  return {
    _id,
    id,
    role: preparedRole || {
      value: 0,
      label: roleLabel || 'Role not selected',
    },
    is_primary_contact: pivot?.is_primary_contact,
  };
};
